import React from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";
import LoadingBlock from "../components/loader/LoadingBlock";
import Layout from "../layouts/Layout";
import { EployeeDetailsPage } from "../pages/EployeeDetailsPage";
import { EployeePage } from "../pages/EployeePage";
import { OneCZupRolePage } from "../pages/OneCZupRolePage";
import { Paths } from "./paths";
import { IikoRolePage } from "../pages/IikoRolePage";
import { IikoDepartmentPage } from "../pages/IikoDepartmentPage";
import { OneCZupDepartmentPage } from "../pages/OneCZupDepartmentPage";
import { ISpringDepartmentPage } from "../pages/ISpringDepartmentPage";

const IntegrationSettingsTable = React.lazy(() => import("../features/integration-setting-table/integrationSettingsTable"));
const ErrorNotFound = React.lazy(() => import("../components/error/ErrorNotFound"));

const router = createHashRouter([
    {
        path: Paths.main,
        element: <Layout />,
        children: [
            {
                index: true,
                element: (
                    <React.Suspense fallback={<LoadingBlock />}>
                        <IntegrationSettingsTable />
                    </React.Suspense>
                ),
            },
            {
                path: Paths.oneCZupRoles,
                element: (
                    <React.Suspense fallback={<LoadingBlock />}>
                        <OneCZupRolePage />
                    </React.Suspense>
                ),
            },
            {
                path: Paths.iikoRoles,
                element: (
                    <React.Suspense fallback={<LoadingBlock />}>
                        <IikoRolePage />
                    </React.Suspense>
                ),
            },
            {
                path: Paths.oneCZupDepartments,
                element: (
                    <React.Suspense fallback={<LoadingBlock />}>
                        <OneCZupDepartmentPage />
                    </React.Suspense>
                ),
            },
            {
                path: Paths.iikoDepartments,
                element: (
                    <React.Suspense fallback={<LoadingBlock />}>
                        <IikoDepartmentPage />
                    </React.Suspense>
                ),
            },
            {
                path: Paths.iSpringDepartments,
                element: (
                    <React.Suspense fallback={<LoadingBlock />}>
                        <ISpringDepartmentPage />
                    </React.Suspense>
                ),
            },
            {
                path: Paths.employees,
                element: (
                    <React.Suspense fallback={<LoadingBlock />}>
                        <EployeePage />
                    </React.Suspense>
                ),
            },
            {
                path: `${Paths.employees}/:id`,
                element: (
                    <React.Suspense fallback={<LoadingBlock />}>
                        <EployeeDetailsPage />
                    </React.Suspense>
                ),
            },
            {
                path: "*",
                element: (
                    <React.Suspense fallback={<LoadingBlock />}>
                        <ErrorNotFound />
                    </React.Suspense>
                ),
            },
        ],
    },
]);

export const Routers = () => {
    return <RouterProvider router={router} />
};
